/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Sara API
 * Sara AI Video Interviewer API
 * OpenAPI spec version: 1.0
 */

export type TranscriptTurnDtoSpeaker = typeof TranscriptTurnDtoSpeaker[keyof typeof TranscriptTurnDtoSpeaker];


export const TranscriptTurnDtoSpeaker = {
  SARA: 'SARA',
  CANDIDATE: 'CANDIDATE',
} as const;
